// test1088
(1088 && 0);
